import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";

bootstrapUtils.addStyle(Button, "grey");

function DebtButton(props) {
  const { onClick } = props;

  return (
    <Button
      className="btn-fn-decisions-button"
      bsStyle="primary"
      onClick={onClick}
    >
      Debt
    </Button>
  );
}

export default DebtButton;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/debt-button.js